import React, { useState, useEffect, useCallback } from "react";
import axiosConfig from "../Service/axiosConfig";
import { useParams } from "react-router-dom";
import { PopupModal } from "../Components";
import Masonry from "react-masonry-css";
import {
  MdKeyboardArrowLeft, MdOutlineNavigateNext, MdOutlineNavigateBefore, MdDeleteOutline,
  MdPlayCircleFilled, MdPhotoLibrary, MdOutlineVideoLibrary
} from "react-icons/md";
import Modal from "react-bootstrap/Modal";
import { PostPop } from "../Components/Post/PostPop";
import { useScrollContext } from "../Utils/ScrollContext";
import { PostUpload } from "./postUpload";

const PostsPageGrid = (props) => {
  const [photoShow, setphotoShow] = useState(false);
  const [item, setItem] = useState();
  const [popUpIdx, setpopUpIdx] = useState();
  const { id } = useParams();
  const { profile_id } = props;
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [Data, SetData] = useState([]);
  const [popupType, setpopupType] = useState("");
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1020);
  const [nextUrl, setNextUrl] = useState(null);
  const { registerLoadMore } = useScrollContext();
  const [postUploadData, setPostUploadData] = useState(false);
  const [showVideoModal, setShowVideoModal] = useState(false);
  const [showPhotoModal, setShowPhotoModal] = useState(false);
  const handleResize = () => {
    setIsMobile(window.innerWidth < 1020);
  };

  const GetData = async () => {
    setLoading(true);
    try {
      const response = await axiosConfig.get(
        `/accounts/model-images/?profile=${profile_id ? profile_id : id}&is_active=true`
      );
      SetData(response.data.results);
      setNextUrl(response.data.next);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const [ModelShow, setModelShow] = useState(false);
  const handleEditProfileClose = () => {
    setModelShow(false);
    GetData();
    setShowPhotoModal(false);
    setShowVideoModal(false);
    setPostUploadData(false);
  };

  const [SuccessMessage, setSuccessMessage] = useState("");
  const successEvnet = () => {
    setModelShow(false);
    GetData();
    setpopupType("");
  };

  const DeleteProject = (pid) => {
    axiosConfig
      .delete(`/accounts/model-images/${pid}/`)
      .then(() => {
        setSuccessMessage("Photo Deleted Successfully !");
        setpopupType("success");
        setModelShow(false);
        GetData();
      })
      .catch(() => {
        setpopupType("error");
      });
  };
  const handleInfiniteScroll = useCallback(async () => {
    if (loading2 || !nextUrl) return;
    setLoading2(true);
    try {
      const resp = await axiosConfig.get(nextUrl);
      SetData((prev) => [...prev, ...resp.data.results]);
      setNextUrl(resp.data.next);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading2(false);
    }
  }, [loading2, nextUrl]);

  useEffect(() => {
    registerLoadMore(handleInfiniteScroll);
    return () => registerLoadMore(null);
  }, [handleInfiniteScroll, registerLoadMore]);

  useEffect(() => {
    GetData();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleHidePostEvent = () => {
    GetData();
  };

  const handleClickEvent = (clickevent) => {
    if (clickevent === "next") {
      const newitem = Data[popUpIdx + 1];
      if (newitem) {
        setItem(newitem);
        setpopUpIdx(popUpIdx + 1);
      }
    } else {
      const newitem = Data[popUpIdx - 1];
      if (newitem) {
        setItem(newitem);
        setpopUpIdx(popUpIdx - 1);
      }
    }
  };

  const Uploadprops = {
    handleEditProfileClose, loading, setLoading, popupType, setpopupType, profile_id, id,
    showPhotoModal, setShowPhotoModal, showVideoModal, setShowVideoModal
  }
  return (
    <>
      <button className="btn btn-primary" onClick={() => setModelShow(true)}>
        Upload Gallery
      </button>
      <div className="products-container">
        {loading ? (
          <div className="loader-container">
            <img src={require("./images/loader.gif")} alt="Loading..." />
          </div>
        ) : (
          <>
            {Data.length > 0 && (
              <div className="post-data post-grid">
                <Masonry
                  breakpointCols={3}
                  className="my-masonry-grid"
                  columnClassName="my-masonry-grid_column"
                >
                  {
                    Data.map((itemObj, index) => {
                      const isVideo = !!itemObj.video_url;
                      return (
                        <div className="post-item" key={index}>
                          <div className="post-inner-container" style={{ position: "relative" }}>
                            <div className="post-image"  >
                              <img src={isVideo ? itemObj.thumbnail : itemObj.image} className="post-img" alt={itemObj?.profile?.full_name} onClick={() => { setphotoShow(true); setItem(itemObj); setpopUpIdx(index) }} />
                              <button className="btn btn-default" onClick={(e) => { DeleteProject(itemObj.id) }}><MdDeleteOutline /></button>
                              {isVideo && (
                                <div className="video-play-icon">
                                  <MdPlayCircleFilled size={36} />
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      )
                    })
                  }
                </Masonry>

                {loading2 && (
                  <div className="loader-container">
                    <img src={require("./images/loader.gif")} alt="Loading..." />
                  </div>
                )}
              </div>
            )}
          </>
        )}
      </div>
      <Modal
        size="lg"
        centered
        show={ModelShow}
        onHide={handleEditProfileClose}
        className="edit-profile-popup"
      >
        <Modal.Header closeButton>
          <Modal.Title>Add Photos</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {postUploadData == false &&
            <div className="row g-3">
              <div className="col-md-6">
                <div className="card h-100">
                  <div className="card-body text-center d-flex flex-column justify-content-center" style={{ minHeight: "220px" }}>
                    <MdPhotoLibrary size={42} className="mb-2 mx-auto" />
                    <h5>Upload Photos</h5>
                    <p className="text-muted mb-3">Open the regular photo uploader.</p>
                    <button className="btn btn-primary" onClick={() => { setShowPhotoModal(true); setPostUploadData(true); }}>
                      Upload Photos
                    </button>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="card h-100">
                  <div className="card-body text-center d-flex flex-column justify-content-center" style={{ minHeight: "220px" }}>
                    <MdOutlineVideoLibrary size={42} className="mb-2 mx-auto" />
                    <h5>Upload Audition Video</h5>
                    <p className="text-muted mb-3">Upload one supported video under 50MB.</p>
                    <button className="btn btn-primary" onClick={() => { setShowVideoModal(true); setPostUploadData(true); }}>
                      Upload Audition Video
                    </button>
                  </div>
                </div>
              </div>
            </div>
          }
          {postUploadData && <PostUpload {...Uploadprops} />}
        </Modal.Body>
      </Modal>
      {popupType !== "" && (
        <PopupModal
          popupType={popupType}
          successEvnet={successEvnet}
          Message={SuccessMessage}
        />
      )}
      <Modal
        size="lg"
        centered
        show={photoShow}
        onHide={() => setphotoShow(false)}
        className="viewphoto-popup"
      >
        <Modal.Header className="show-only-mobile">
          <div className="model-header-wid">
            <div className="model-header-popup">
              <div className="model-popup-back">
                <MdKeyboardArrowLeft
                  onClick={() => setphotoShow(false)}
                  size={30}
                />
              </div>
              <p className="posttitle">Post</p>
            </div>
          </div>
        </Modal.Header>
        <Modal.Body>
          <PostPop item={item} handleHideEvent={handleHidePostEvent} />
          <div className="navigation-buttons">
            <MdOutlineNavigateBefore
              className="nav-prev"
              onClick={() => handleClickEvent("prev")}
            />
            <MdOutlineNavigateNext
              className="nav-next"
              onClick={() => handleClickEvent("next")}
            />
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export { PostsPageGrid };
